﻿import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

import checkoutModule from './modules/checkout/checkoutModule';
import offeringpageModule from './modules/offeringpage/offeringpageModule';
import creditaccountModule from './modules/creditaccount/creditaccountModule';
import digitalvalidationModule from './modules/digitalvalidation/digitalvalidationModule';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const state = {
    cart: {
        lineItems: []
    },
    showShippingAddressModal: false
};

export default new Vuex.Store({
    state,
    //getters,
    //mutations,
    //actions,
    strict: debug,
    modules: {
        checkout : checkoutModule,
        offeringpage : offeringpageModule,
        creditaccount : creditaccountModule,
        digitalvalidation : digitalvalidationModule
    },
});
